import axiosInstance from "../utils/axiosInstance";

export interface ExtractChatMessagePayload {
  role: "user" | "assistant";
  content: string;
}

interface AskExtractChatResponse {
  answer?: string;
}

export interface AskExtractChatOptions {
  /**
   * Inline extracted text. When provided, the backend uses this directly
   * instead of looking up the text by jobId — robust against the case where
   * the upload job's metadata.contentTextKey hasn't been written yet (job
   * still PROCESSING) or never wrote (job failed at a late step).
   */
  extractedText?: string;
}

export const askExtractChat = async (
  jobId: string,
  question: string,
  history: ExtractChatMessagePayload[],
  options: AskExtractChatOptions = {},
): Promise<string> => {
  try {
    const response = await axiosInstance.post<AskExtractChatResponse>("/extract-chat/ask", {
      jobId,
      question,
      history,
      ...(options.extractedText ? { extractedText: options.extractedText } : {}),
    });

    return response.data.answer?.trim() || "";
  } catch (error: any) {
    // Backend uses `createErrorResponse` which serialises as
    //   { error: true, message: <string>, requestId: <string> }
    // — so the human-readable text lives in `data.message`. Be defensive
    // for older error shapes where `data.error` is the string itself.
    const data = error.response?.data;
    const messageField = typeof data?.message === 'string' ? data.message : '';
    const errorField = typeof data?.error === 'string' ? data.error : '';
    const message = messageField || errorField || "Failed to ask a question about the extracted content.";
    throw new Error(message);
  }
};
